// import { Injectable, OnInit } from '@angular/core';
// import { Socket } from 'ngx-socket-io';
// import { BehaviorSubject, Subject } from 'rxjs';
// @Injectable({
//   providedIn: 'root',
// })
// export class SocketService implements OnInit {
//   public newReCon = new Subject();
//   public newReConProcessing = new Subject();
//   public deleteReCon = new Subject();
//   public sync_invoices = new Subject();
//   public d_sync = new Subject();
//   public sync_sac_hsn_codes = new Subject();
//   public sync_taxpayers = new Subject();
//   public sync_completed = new Subject();
//   public bulkIRN = new Subject();
//   public status_bulkIRN = new Subject();
//   public locked_sync_invoices = new Subject();
//   public simpleRecon = new Subject();
//   public simple_recon_success = new Subject();
//   readonly newInvoice = new BehaviorSubject(null);
//   readonly isContactAdded = new BehaviorSubject(null);
//   readonly newPosChecks = new BehaviorSubject(null);
//   readonly newPosUploads = new BehaviorSubject(null);
//   readonly summaryData = new BehaviorSubject(null);
//   private company;

//   constructor(private socket: Socket) {}
//   ngOnInit() {}
//   connectMe() {
//     setInterval(() => {
//       console.log(this.socket.ioSocket.connected);
//     }, 2000);
//     console.log('connectMe invoked');
//     this.socket.on('connection', () => {
//       console.log('socket connected');
//     });
//     this.socket.on('connect-me', () => {
//       console.log('socket connect-me event');
//     });
//     this.socket.on('message', (data) => {
//       console.log('socket message: ', data);
//       this.newInvoiceFun(data);
//       // this.newInvoice.next(null);
//       console.log(data);
//       switch (data?.message.message) {
//         case 'POS Checks':
//           this.newPosChecks.next(data?.message);
//           console.log(data?.message);
//           break;
//         case 'Invoices Syncing':
//           this.sync_invoices.next(data?.message);
//           break;
//         case 'D syncing':
//           this.d_sync.next(data?.message);
//         case 'Item Sync':
//           this.sync_sac_hsn_codes.next(data?.message);
//           break;
//         case 'Taxpayer Sync':
//           this.sync_taxpayers.next(data?.message);
//           break;
//         case 'Sync Completed':
//           this.sync_completed.next(data?.message);
//           break;
//         case 'Delete Recon':
//           this.deleteReCon.next(data?.message);
//           break;
//         case 'Create Recon':
//           this.newReCon.next(data?.message);
//           break;
//         case 'Recon Processing':
//           this.newReConProcessing.next(data?.message);
//           break;
//         case 'File Processing':
//           this.newPosUploads.next(data?.message);
//           break;
//         case 'POS Uploads Error':
//           this.newPosUploads.next(data?.message);
//           break;
//         case 'POS Uploads':
//           this.newPosUploads.next(data.message);
//           break;

//         case 'BULK IRN Generation':
//           this.bulkIRN.next(data?.message);
//           break;
//         case 'irn generated completed':
//           this.status_bulkIRN.next(data?.message);
//           break;
//         case 'Sync Bulk Invoices':
//           this.locked_sync_invoices.next(data?.message);
//           break;

//         case 'Simple reconciliation file':
//           this.simpleRecon.next(data?.message);
//           break;
//         case 'Simple reconciliation file uploaded':
//           this.simple_recon_success.next(data?.message);
//           break;
//       }
//     });

//     this.socket.connect();
//   }

//   newInvoiceFun(data) {
//     this.company = JSON.parse(localStorage.getItem('company'));
//     if (this.company.company_code == data.message.company) {
//       this.newInvoice.next(data);
//     } else {
//       this.summaryData.next(data);
//     }
//   }

//   disconnect() {
//     this.socket.removeAllListeners();
//     this.socket.disconnect();
//   }
// }

import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { initSocket } from '../../shared/socket';

@Injectable({
  providedIn: 'root',
})
export class SocketService implements OnInit {
  public newReCon = new Subject();
  public newReConProcessing = new Subject();
  public deleteReCon = new Subject();
  public sync_invoices = new Subject();
  public d_sync = new Subject();
  public sync_sac_hsn_codes = new Subject();
  public sync_taxpayers = new Subject();
  public sync_completed = new Subject();
  public bulkIRN = new Subject();
  public status_bulkIRN = new Subject();
  public redoBinError = new Subject();
  public redoBinErrorCompleted = new Subject();
  public locked_sync_invoices = new Subject();
  public simpleRecon = new Subject();
  public purchaseInvoice = new Subject();
  public simple_recon_success = new Subject();
  public purchaseInvocieSuccess = new Subject();
  readonly newInvoice = new BehaviorSubject(null);
  readonly isContactAdded = new BehaviorSubject(null);
  readonly newPosChecks = new BehaviorSubject(null);
  readonly newPosUploads = new BehaviorSubject(null);
  readonly summaryData = new BehaviorSubject(null);
  readonly documentBinInsert = new BehaviorSubject(null);
  // readonly redoBinError = new BehaviorSubject(null)
  // readonly redoBinErrorCompleted = new BehaviorSubject(null)
  readonly simpleReconFileUploading = new BehaviorSubject(null);
  readonly simpleReconFileUploaded = new BehaviorSubject(null);
  readonly simpleReconException = new BehaviorSubject(null);
  readonly invoiceCreated = new BehaviorSubject(null);
  readonly invoiceDeleted = new BehaviorSubject(null);
  readonly invoiceDuplicate = new BehaviorSubject(null);
  readonly redoError = new BehaviorSubject(null);
  readonly bulkUploadInvCount = new BehaviorSubject(null);
  readonly bulkUploadCreated = new BehaviorSubject(null);
  readonly bulkUploadCompleted = new BehaviorSubject(null);
  readonly bulkUploadException = new BehaviorSubject(null);
  readonly tabletConf = new BehaviorSubject(null);
  readonly finalizePRCompleted = new BehaviorSubject(null);
  private company;
  socketIO: any;
  private isConnected = false;
  constructor() {} // private socket: Socket
  ngOnInit() {}
  connectMe() {
    if (this.isConnected) {
      console.log('Socket already connected.');
      return;
    }

    console.log('connectMe invoked');
    this.socketIO = initSocket();

    this.socketIO?.on('connect', () => {
      this.isConnected = true;
      console.log('Connected to the server');
    });

    this.socketIO?.on('disconnect', () => {
      this.isConnected = false;
      console.log('Socket disconnected from server');
    });

    this.registerSocketEvents();

    this.socketIO?.on('error', (error) => {
      console.error('Socket error:', error);
    });
  }

  newInvoiceFun(data) {
    // Ensure data is not null and has expected structure
    if (!data) return;
    const data_obj = { message: data };
    this.newInvoice.next(data_obj);
  }

  disconnect() {
    if (this.socketIO) {
      this.socketIO?.offAny();
      this.socketIO?.removeAllListeners();
      this.socketIO?.disconnect();
      this.socketIO = null;
      this.isConnected = false;
      this.clearSubjects();
      console.log('Socket disconnected');
    }
  }

  clearSubjects() {
    this.newInvoice.next(null);
    this.newPosChecks.next(null);
    this.newPosUploads.next(null);
    this.bulkIRN.next(null);
    // etc.
  }

  private registerSocketEvents() {
    this.socketIO?.offAny(); // Clear previous `onAny` handlers

    this.socketIO?.onAny((event, ...args) => {
      console.log(`Received event: ${event}, with data:`, args);

      if (event === 'custom_socket') {
        this.company = JSON.parse(localStorage.getItem('company'));
        const data = args[0];

        if (this.company?.company_code === data?.company) {
          console.log(data?.message, ' data == ', data);
          this.newInvoice.next({ message: data });
          // this.newInvoice.next(null);
          const message = data?.message;
          switch (message) {
            case 'POS Checks':
              this.newPosChecks.next(data?.data);
              this.newPosChecks.next(null); // clear
              break;
            case 'Invoices Syncing':
              this.sync_invoices.next(data?.data);
              break;
            case 'D syncing':
              this.d_sync.next(data?.data);
              break;
            case 'Delete Recon':
              this.deleteReCon.next(data?.data);
              break;
            case 'Create Recon':
              this.newReCon.next(data?.data);
              break;
            case 'Recon Processing':
              this.newReConProcessing.next(data?.data);
              break;
            case 'File Processing':
            case 'POS Uploads Error':
            case 'POS Uploads':
              this.newPosUploads.next(data?.message);
              this.newPosUploads.next(null); // clear
              break;
            case 'BULK IRN Generation':
            case 'UUID Backgroung Jobs Started':
              this.bulkIRN.next(data);
              break;
            case 'irn generated completed':
              this.status_bulkIRN.next(data);
              break;
            case 'Sync Bulk Invoices':
              this.locked_sync_invoices.next(data?.message);
              break;
            case 'Simple reconciliation file':
              this.simpleRecon.next(data);

              this.simpleRecon.next(null);
              break;
            case 'Purchase Import file':
              this.purchaseInvoice.next(data?.message);
              this.purchaseInvoice.next(null); // clear
              break;
            case 'Purchase Import file uploaded':
              this.purchaseInvocieSuccess.next(data?.message);
              this.purchaseInvocieSuccess.next(null); // clear
              break;

            case 'Simple reconciliation file uploaded':
              this.simple_recon_success.next(data);
              this.simple_recon_success.next(null); // clear
              break;
            case 'Bulk Invoice Reprocess':
              this.redoBinError.next(data);
              break;
            case 'Bulk Invoices Reprocess Completed':
              this.redoBinErrorCompleted.next(data);
              break;
            case 'Finalize_PR_Completed':
              this.finalizePRCompleted.next(data);
              // this.finalizePRCompleted.next(null); // clear
              break;
          }
        }
      }
    });
  }
}
